module.exports = __webpack_public_path__ + "img/content-blocks.f2c04ec8.svg";